import { BaseModel } from "@blue-chip/core";
import Fee from "./Fee";

export default class FeePayment extends BaseModel {
  static get belongsTo() {
    return [Fee];
  }
}
